import React from "react";
import Layout from "../common/Layout";
import { FEATURES_INFRA } from "../data/constants";

// import cardImage from "../assets/featureImage.png";
import TestStandardsSection from "../components/infra/TestStandardsSection";
import OurProcessSection from "../components/infra/OurProcessSection";
import FacilitySection from "../components/infra/FacilitySection";
import PageHeader from "../common/PageHeader";
import PageHeaderWithLoader from "../common/PageHeaderWithLoader";
import FeaturesSection2 from "../components/home/FeaturesSection2";
const Infrastructure = () => (
  <Layout>
    <PageHeaderWithLoader title="Infrastructure" media={{ type: "image", src: process.env.PUBLIC_URL + "/assets/infraBackground.webp" }} />
    <FeaturesSection2 features={FEATURES_INFRA}  />
    <OurProcessSection />
    <TestStandardsSection />
    <FacilitySection />
  </Layout>
);

export default Infrastructure; 
